<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container" style="width:100% !important">
                <div class="page-name">{{  page_header }}</div>
                <button type="submit" v-on:click.prevent="returnOnListing()" class="btn btn-primary waves-effect pull-right">Back</button>
            </div>
            <!-- page content -->
            <div class="admin-page-content">
                <!-- Forms -->
                <div class="forms-container">
                    <div class="row no-margin">
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Name :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input @input="name_error_msg = ''" v-model="fields.name" class="form-control" type="text"/>
                                <div class="requiredstar">*</div>
                                <span class="help is-danger">{{name_error_msg}}</span>
                            </div>
                        </div>
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Branch :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input @input="branch_error_msg = ''" v-model="fields.branch" class="form-control" type="text"/>
                                <div class="requiredstar">*</div>
                                <span class="help is-danger">{{branch_error_msg}}</span>
                            </div>
                        </div>
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Address :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <textarea @input="addressError = ''" v-model="fields.address" class="form-control" type="text"></textarea>
                                <div class="requiredstar">*</div>
                                <span class="help is-danger">{{addressError}}</span>
                            </div>
                        </div>
                        <template v-if="isNonVVGDealer == 'NO'">
                            <div class="col-6 forms-block">
                                    <div class="form-label">Excede Location :
                                        <input class="ml-2" id="isExcedeLocation" v-model="fields.isExcedeLocation" type="checkbox"/>
                                    </div>
                            </div>
                        </template>
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Ship To :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input @input="ship_to_error_msg = ''" v-model="fields.shipTo" class="form-control" type="text" maxlength="190"/>
                                <div class="requiredstar">*</div>
                                <span class="help is-danger">{{ship_to_error_msg}}</span>
                            </div>
                        </div>
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Bill To :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input @input="bill_to_error_msg = ''" v-model="fields.billTo" class="form-control" type="text" maxlength="190"/>
                                <div class="requiredstar">*</div>
                                <span class="help is-danger">{{bill_to_error_msg}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="clearfix"></div>

                    <!-- Buttons -->
                    <div class="row clearfix"></div>
                    <div class="button-demo">
                        <input id="addLocBtn" :disabled="disableButtons.saveButton" type="submit" :value="buttonNames.saveButton" class="btn btn-primary" v-on:click.prevent="createRecord()">
                        <input id="addAndContinueLocBtn" :disabled="disableButtons.updateButton" type="submit" :value="buttonNames.updateButton" class="btn btn-primary" v-on:click.prevent="updateRecord()">
                        <input id="CancelBenifit" :disabled="disableButtons.cancel" type="submit" :value="buttonNames.cancel" class="btn btn-primary" v-on:click.prevent="returnOnListing()">
                    </div>
                </div>
                <!-- Forms -->
            </div>
            <!-- page content -->
        </div>
        <app-footer></app-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    import Vue from 'vue';
    import vSelect from 'vue-select';
    import { Form } from 'bootstrap-vue/es/components';
    import { FormRadio } from 'bootstrap-vue/es/components';
    import Footer from '@/components/partials/Footer';
    import {HTTP} from '../../http-common';
    import EventBus from '.././event-bus';
    import {commonMixins} from '../../mixins/commonMixins';
    // import vue2Dropzone from 'vue2-dropzone';
    // import 'vue2-dropzone/dist/vue2Dropzone.min.css';

    /* Vue FlatPickr */
    // import flatPickr from 'vue-flatpickr-component';
    // import 'flatpickr/dist/flatpickr.css';

    /* Bootstrap Data-Picker */
    // import datePicker from 'vue-bootstrap-datetimepicker';
    // import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
    
    //import tinymce from 'vue-tinymce-editor';
    var self;
    export default {
        name: 'Center',
        mixins: [commonMixins],
        components: {
            'v-select': vSelect,
            'app-footer': Footer,

            // 'vueDropzone': vue2Dropzone,
            // 'tinymce': tinymce,
            //flatPickr,
            // datePicker,
        },
        data() {
            return {
                page_header:'Location',
                name_error_msg:'',
                branch_error_msg:'',
                addressError:"",
                ship_to_error_msg : "",
                bill_to_error_msg : "",
                fields:{
                    name:"",
                    branch:"",
                    isExcedeLocation : 0,
                    address: "",
                    shipTo:"",
                    billTo:""
                },
                buttonNames : {
                    saveButton : 'Save',
                    updateButton : 'Update',
                    cancel : 'Cancel',
                },
                disableButtons : {
                    saveButton : false,
                    updateButton : false
                },
                isNonVVGDealer: 'NO',
            }
        },
        beforeMount: function () {
            self = this;
            EventBus.$emit("menu-selection-changed", "listlocations");
        },
        mounted: function () {
            self.isNonVVGDealer = process.env.NON_VVG_DEALER;
            var id = self.$route.params.id;
            if(id > 0){
                $("#addLocBtn").hide();
                $("#addAndContinueLocBtn").show();
                /* self.buttonNames.saveButton = 'Update'; */
                self.page_header = 'Edit Location';
                self.getRecord();
            } else {
                $("#addAndContinueLocBtn").hide();
                $("#addLocBtn").show();
            }
            
        },
        methods: {
            returnOnListing() {
                self.$router.push('/locations');
            },
            getRecord(){
                //alert('here');
                self.disableButtons.saveButton = true;
                var id = self.$route.params.id;
                var config = {
                    headers: {Authorization:localStorage.getItem("access_token")},
                };
                HTTP.get("location/"+id, config)
                    .then(function (data) {
                        //console.log('locationdata', data);
                        if (data.status == 200) {
                            self.fields.name = data.data.name;
                            self.fields.branch = data.data.branch;
                            self.fields.address = data.data.address;
                            if(data.data.is_excede != '' && data.data.is_excede != 'null' && typeof(data.data.is_excede) != 'undefined') {
                                self.fields.isExcedeLocation = data.data.is_excede == 'yes' ? 1 : 0;
                            }
                            self.fields.shipTo = data.data.ship_to;
                            self.fields.billTo = data.data.bill_to;
                            self.disableButtons.saveButton = false;
                        }
                    })
                    .catch(function (error) {
                        self.catchHandler(error);
                    })
            },
            validateForm() {
                var error = false;
                self.name_error_msg = '';
                self.branch_error_msg = '';
                self.ship_to_error_msg = '';
                self.bill_to_error_msg = '';

                if(!self.fields.name || self.fields.name == null || self.fields.name == "") {
                    self.name_error_msg = "The name field is required.";
                    error = true;
                }

                if(!self.fields.branch || self.fields.branch == null || self.fields.branch == "") {
                    self.branch_error_msg = "The branch field is required.";
                    error = true;
                }
                
                if(!self.fields.address || self.fields.address == null || self.fields.address == "") {
                    self.addressError = "The address field is required.";
                    error = true;
                }

                if(!self.fields.shipTo || self.fields.shipTo == null || self.fields.shipTo == "") {
                    self.ship_to_error_msg = "The ship to field is required.";
                    error = true;
                }

                if(!self.fields.billTo || self.fields.billTo == null || self.fields.billTo == "") {
                    self.bill_to_error_msg = "The bill to field is required.";
                    error = true;
                }
                return error;
            },
            createRecord() {
                var error = self.validateForm();
                if(!error) {
                    self.disableButtons.saveButton = true;
                    HTTP.post("location", self.fields)
                        .then(function (data) {
                            //console.log('after create', data)

                            self.buttonNames.saveButton = "Save";
                            self.disableButtons.saveButton = false;
                            /*$('#loginbtn').text("Login");
                            $("#loginbtn").attr("disabled", false);*/

                            if (data.status == 200) {
                                self.showSAlert('Location added successfully', 'success', false);
                                self.returnOnListing();
                            } else {
                                if (data.status == 201) {
                                    self.showSAlert(data.data.content[0], 'info', false);
                                } else {
                                    self.showSAlert(data.data.content, 'error', false);
                                }
                            }
                        })
                        .catch(function (error) {
                            self.error_msg_login = "";
                            self.buttonNames.saveButton = "Save";
                            self.disableButtons.saveButton = false;
                            self.catchHandler(error);
                        })

                }
            },
            updateRecord() {
                var error = self.validateForm();
                var id = self.$route.params.id;

                if(!error) {
                    self.disableButtons.updateButton = true;
                    HTTP.put("location/"+id, self.fields)
                        .then(function (data) {
                            //console.log('after update', data)
                            self.buttonNames.updateButton = "Update";
                            self.disableButtons.updateButton = false;
                            /*$('#loginbtn').text("Login");
                            $("#loginbtn").attr("disabled", false);*/

                            if (data.status == 200) {
                                self.showSAlert('Location updated successfully','success',false);
                                self.returnOnListing();
                            } else {
                                if (data.status == 201) {
                                    self.showSAlert(data.data.content[0], 'info', false);
                                } else {
                                    self.showSAlert(data.data.content, 'error', false);
                                }
                            }
                        })
                        .catch(function (error) {
                            self.error_msg_login = "";
                            self.buttonNames.updateButton = "Update";
                            self.disableButtons.updateButton = false;
                            self.catchHandler(error);
                        })

                }
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Location/Edit.vue